import {CertificateData} from "../types/certificate-modal.types";

export const defaultCertificateData: CertificateData = {
  id: 0,
  certificateNumber: 'Новый',
  comment: ''
}
